import React from 'react';
import { messageError, PageSection } from '@deltaohm/ant-components';
import {
  Alert,
  Col,
  Row,
  Typography,
  Result,
  Button,
} from 'antd';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ErrorList from 'antd/lib/form/ErrorList';

import SerialPort from '../utils/serial';

export const AVAILABLE_H2SERIES_MODELS = {
  HD2010UC: 'HD2010UC',
  HD2010UC_A: 'HD2010UC/A',
  HD2110L: 'HD2110L',
};

const SoundMeterHD2SerieManagePage = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const handleConnectError = () => {
    messageError({
      content: (
        <>
          <Typography.Title level={5}>
            {t('localSoundMeters.connect.cannotConnect.title')}
          </Typography.Title>
          <ErrorList errors={[
            t('localSoundMeters.connect.cannotConnect.link'),
            t('localSoundMeters.connect.cannotConnect.port'),
            t('localSoundMeters.connect.cannotConnect.model'),
            t('localSoundMeters.connect.cannotConnect.usb'),
          ]}
          />
        </>
      ),
    });
  };

  const handleHD2SerieConnect = async () => {
    const port = await SerialPort.connect({
      baudRate: 230400,
      // flowControl: 'hardware',
      bufferSize: 1024,
    });
    const serialPort = new SerialPort(port);

    const modelNumber = await serialPort.writeStringWithResponseString('SET:INSTR_MODEL:?\r\n', 3000, (data) => {
      if (data.length === 28 && data.startsWith('SET:INSTR_MODEL:')) {
        const splitted = data.split(':');
        return splitted[2].trim();
      }
      return null;
    });

    if (modelNumber == null || !Object.values(AVAILABLE_H2SERIES_MODELS).includes(modelNumber)) {
      await serialPort.disconnect(port);
      handleConnectError();
      return;
    }

    await serialPort.disconnect(port);
    navigate('/localSoundMeterHD2Series', { replace: true });
  };

  const handleXPT800Connect = async () => {
    const port = await SerialPort.connect({
      baudRate: 230400,
      // flowControl: 'hardware',
      bufferSize: 1024,
    });
    const serialPort = new SerialPort(port);

    const serialNumber = await serialPort.writeStringWithResponseString('CMD:INSTR_ID:?\r\n', 3000, (data) => {
      if (data.startsWith('CMD:INSTR_ID:?:')) {
        const stripped = data.replace('CMD:INSTR_ID:?:', '');
        const splitted = stripped.split(' ');
        return splitted[1].trim();
      }
      return null;
    });

    if (serialNumber == null) {
      await serialPort.disconnect(port);
      handleConnectError();
      return;
    }

    await serialPort.disconnect(port);
    navigate('/localSoundMeterXPT800s', { replace: true });
  };

  const renderConnect = () => {
    if (!SerialPort.isAvailable()) {
      return (
        <Row>
          <Col xs={24}>
            <Alert
              message={t('localSoundMeters.connect.serial')}
              description={t('localSoundMeters.connect.serialUnavailable')}
              type="error"
              showIcon
            />
          </Col>
        </Row>
      );
    }
    return (
      <Row>
        <Col xs={24}>
          <Result
            title={t('localSoundMeters.connect.infoTitle')}
            subTitle={t('localSoundMeters.connect.infoSubTitle')}
            extra={[
              <Button type="primary" key="connectXPT800" onClick={handleXPT800Connect}>
                {t('localSoundMeters.connect.xpt800Button')}
              </Button>,
              <Button type="primary" key="connectOldVersions" onClick={handleHD2SerieConnect}>
                {t('localSoundMeters.connect.oldVersionsButton')}
              </Button>,
            ]}
          />
        </Col>
      </Row>
    );
  };

  return (
    <PageSection
      title={t('localSoundMeters.connect.title')}
      subtitle={t('localSoundMeters.connect.subtitle')}
    >
      {renderConnect()}
    </PageSection>
  );
};

export default SoundMeterHD2SerieManagePage;
